export default {
    // list: [
    //     {
    //         label: '仓库状态',
    //         value: '0',
    //         prop: 'whStatus',
    //         optionNum: 'SRM_WH_STATUS',
    //         type: 'mSelect',
    //         disabled: true,
    //         hidenInSub: true
    //     },
    //     {
    //         label: '审批状态',
    //         value: '2',
    //         prop: 'approveStatus',
    //         type: 'mSelect',
    //         optionNum: 'SRM_PHY_WH_AUDIT_STATUS',
    //         disabled: true,
    //         hidenInSub: true
    //     },
    //     {
    //         label: '合同状态',
    //         value: '',
    //         prop: 'contractStatus',
    //         type: 'mSelect',
    //         optionNum: 'SYS_CONTRACT_WH_STATUS',
    //         disabled: true,
    //         hidenInSub: true
    //     },
    //     {
    //         label: '是否特批',
    //         value: '',
    //         prop: 'specialApproveFlag',
    //         type: 'mSelect',
    //         optionNum: 'SRM_SPECIAL_FLAG',
    //         disabled: false,
    //         hidenInSub: true
    //     },
    //     {
    //         label: '仓库名称',
    //         value: '',
    //         prop: 'whName',
    //         type: 'input',
    //         disabled: false,
    //         mustFillInSub: true
    //     },
    //     {
    //         label: '仓库地址',
    //         value: 'eblcDetailAddress',
    //         prop: 'whAddress',
    //         type: 'advance',
    //         'name': '仓库地址',
    //         'unfold': true,
    //         'advanceConfig': [
    //             { 'prop': 'eblcNameCn', 'value': '中文名称' },
    //             { 'prop': 'eblcDetailAddress', 'value': '详细地址' },
    //             { 'prop': 'eblcCode', 'value': '地点代码' }
    //         ],
    //         'tableConfig': [
    //             { 'prop': 'eblcCode', 'value': '地点代码' },
    //             { 'prop': 'eblcNameCn', 'value': '中文名称' },
    //             { 'prop': 'eblcDetailAddress', 'value': '详细地址' }
    //         ],
    //         'advanceUrl': '/ebLocations?',
    //         'cbParams': [
    //             'eblcCode#eblcCode',
    //             'eblcDetailAddress#eblcDetailAddress',
    //             'eblcNameCn#eblcNameCn',
    //             'eblcProvinceName#provinceName',
    //             'eblcProvinceCode#provinceCode',
    //             'eblcCountyName#districtName',
    //             'eblcCountyCode#districtCode',
    //             'eblcTownName#townName',
    //             'eblcTownCode#townCode'
    //         ],
    //         disabled: false,
    //         mustFillInSub: true,
    //         disabledInSub: true
    //     },
    //     // {
    //     //     label: '仓库地址',
    //     //     value: '',
    //     //     prop: 'whAddress',
    //     //     type: 'input'
    //     // },
    //     {
    //         label: '仓库建筑面积（㎡）',
    //         value: '',
    //         prop: 'whSquare',
    //         type: 'input',
    //         disabled: false,
    //         mustFillInSub: true,
    //         isPositiveNum: true
    //     },
    //     // 加权的表单类型weightedInput
    //     {
    //         label: '实用面积(m²)',
    //         value: '',
    //         prop: 'usableArea',
    //         type: 'weightedInput',
    //         isPositiveNum: true,
    //         disabledInSub: true
    //     },
    //     {
    //         label: '产权属性',
    //         value: '',
    //         prop: 'propertyType',
    //         type: 'mSelect',
    //         optionNum: 'SYS_PROPERTY_RIGHTS',
    //         disabled: false
    //     },
    //     {
    //         label: '产权人',
    //         value: '',
    //         prop: 'propertyOwner',
    //         type: 'input',
    //         disabled: false
    //     },
    //     {
    //         label: '管理属性',
    //         value: '',
    //         prop: 'manageType',
    //         type: 'mSelect',
    //         optionNum: 'SRM_WH_MANAGE_ATTRIBUTES',
    //         disabled: false
    //     },
    //     {
    //         label: '产权证编号',
    //         value: '',
    //         prop: 'propertyNo',
    //         type: 'input'
    //     },
    //     {
    //         label: '仓库类型',
    //         prop: 'whType',
    //         value: '',
    //         type: 'mSelect',
    //         optionNum: 'SYS_SU_WH_TYPE',
    //         disabled: false
    //     },
    //     {
    //         label: '供电系统',
    //         value: '',
    //         prop: 'poweredSystemFlag',
    //         type: 'mSelect',
    //         optionNum: 'SRM_WH_POWER_SYSTEM',
    //         disabled: false
    //     },
    //     {
    //         label: '净高（M）',
    //         value: '',
    //         prop: 'whHeight',
    //         type: 'input',
    //         disabled: false,
    //         isPositiveNum: true
    //     },
    //     {
    //         label: '消防验收',
    //         value: '',
    //         prop: 'fireInspection',
    //         optionNum: 'SYS_SU_FIRE_INSPECTION',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '消防设施',
    //         value: '',
    //         prop: 'fireFacilities',
    //         optionNum: 'SYS_SU_FIRE_FACILITIES',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '消防单元面积（㎡）',
    //         value: '',
    //         prop: 'fireUnitArea',
    //         type: 'input',
    //         disabled: false,
    //         isPositiveNum: true
    //     },
    //     {
    //         label: '月台',
    //         value: '',
    //         prop: 'platform',
    //         type: 'mSelect',
    //         optionNum: 'SYS_SU_PLATFORM',
    //         disabled: false
    //     },
    //     {
    //         label: '雨棚',
    //         value: '',
    //         prop: 'canopy',
    //         optionNum: 'SYS_SU_CANOPY',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '地面承压',
    //         value: '',
    //         prop: 'pressure',
    //         optionNum: 'SYS_SU_PRESSURE',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '建筑结构',
    //         value: '',
    //         prop: 'buildingType',
    //         optionNum: 'SYS_SU_BUILDING_TYPE',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '园区通道',
    //         value: '',
    //         prop: 'parkPath',
    //         optionNum: 'SYS_SU_PARK_PATH',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '采光带占比',
    //         value: '',
    //         prop: 'withLighting',
    //         type: 'mSelect',
    //         optionNum: 'SYS_SU_WITH_LIGHTING',
    //         disabled: false
    //     },
    //     {
    //         label: '距市区距离（km）',
    //         value: '',
    //         prop: 'cityDistance',
    //         type: 'input',
    //         disabled: false,
    //         isPositiveNum: true
    //     },
    //     {
    //         label: '地面防尘',
    //         value: '',
    //         prop: 'groundDust',
    //         optionNum: 'SYS_SU_GROUND_DUST',
    //         type: 'mSelect',
    //         disabled: false,
    //         hidenInSub: true
    //     },
    //     {
    //         label: '照明系统',
    //         value: '',
    //         prop: 'lightingSystem',
    //         optionNum: 'SYS_SU_LIGHTING_SYSTEM',
    //         type: 'mSelect',
    //         disabled: false
    //     },
    //     {
    //         label: '办公室',
    //         value: '',
    //         prop: 'officeFlag',
    //         type: 'mSelect',
    //         optionNum: 'SRM_WH_OFFICE',
    //         disabled: false
    //     },
    //     {
    //         label: '员工宿舍',
    //         value: '',
    //         prop: 'dormFlag',
    //         type: 'mSelect',
    //         optionNum: 'SRM_WH_DORM',
    //         disabled: false,
    //         hidenInSub: true
    //     },
    //     // {
    //     //     label: '保安系统',
    //     //     value: '',
    //     //     prop: 'securitySystemFlag',
    //     //     type: 'mSelect',
    //     //     optionNum: 'SYS_SUPPLIER_HAS_NO',
    //     //     disabled: false,
    //     //     hidenInSub: true
    //     // },
    //     {
    //         label: '分公司',
    //         value: 'companyNameCn',
    //         prop: 'companyName',
    //         type: 'advance',
    //         'name': '分公司',
    //         'unfold': true,
    //         'advanceConfig': [
    //             { 'prop': 'companyNameCn', 'value': '分公司名称' },
    //             { 'prop': 'companyCode', 'value': '分公司编码' }
    //         ],
    //         'tableConfig': [
    //             { 'prop': 'companyCode', 'value': '分公司编码' },
    //             { 'prop': 'companyNameCn', 'value': '分公司名称' }
    //         ],
    //         'advanceUrl': '/esCompany/popCompany',
    //         'cbParams': ['companyCode#companyCode', 'companyNameCn#companyNameCn'],
    //         disabled: false
    //     },
    //     {
    //         label: '城市',
    //         value: 'ebplNameCn',
    //         prop: 'cityName',
    //         type: 'advance',
    //         'name': '城市',
    //         'unfold': true,
    //         'advanceConfig': [
    //             { 'prop': 'ebplNameCn', 'value': '中文名称' },
    //             { 'prop': 'ebplCode', 'value': '代码' }
    //         ],
    //         'tableConfig': [
    //             { 'prop': 'ebplCode', 'value': '代码' },
    //             { 'prop': 'ebplNameCn', 'value': '中文名称' },
    //             { 'prop': 'ebplNameEn', 'value': '英文名称' }
    //         ],
    //         'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_CITY&ebplIsAble=ENABLE',
    //         'cbParams': ['ebplCode#ebplCode', 'ebplNameCn#ebplNameCn'],
    //         disabled: false
    //     },
    //     {
    //         label: '单价(元/平方米)',
    //         value: '',
    //         prop: 'unitPrice',
    //         type: 'weightedInput',
    //         isPositiveNum: true
    //     },
    //     {
    //         label: '联系人',
    //         value: '',
    //         prop: 'contacts',
    //         type: 'weightedInput'
    //     },
    //     {
    //         label: '联系电话',
    //         value: '',
    //         prop: 'contactsPhone',
    //         type: 'weightedInput'
    //     },
    //     {
    //         label: '是否地产商',
    //         value: '',
    //         prop: 'factoryFlag',
    //         type: 'mSelect',
    //         optionNum: 'SRM_YES_NO',
    //         hidenInSub: true
    //     },
    //     {
    //         label: '地产商简称',
    //         value: '',
    //         prop: 'factorySign',
    //         type: 'mSelect',
    //         optionNum: 'SRM_WAREHOUSE_FACTORY_SIGN',
    //         // multiple: true,
    //         hidenInSub: true,
    //         hidenInBase: true
    //     },
    //     {
    //         label: '仓库等级',
    //         value: '',
    //         prop: 'warehouseLevel',
    //         type: 'mSelect',
    //         optionNum: 'SRM_REGISTER_WAREHOUSE_LEVEL',
    //         hidenInSub: true
    //     }
    // ],
    // subAppendList: [
    //     {
    //         label: '仓库编码',
    //         value: '',
    //         prop: 'whCode',
    //         type: 'input',
    //         disabledInSub: true,
    //         index: 0
    //     },
    //     {
    //         label: '合同状态',
    //         value: '',
    //         prop: 'contractStatus',
    //         type: 'mSelect',
    //         optionNum: 'PHY_WH_CONTRACT_STATUS',
    //         mustFillInSub: true,
    //         disabledInSub: true,
    //         index: 5
    //     },
    //     {
    //         label: '墙上标识图片',
    //         value: '',
    //         prop: 'wallSignImg',
    //         type: 'upload',
    //         mustFillInSub: true,
    //         index: 6
    //     },
    //     {
    //         label: '单体仓规划图',
    //         value: '',
    //         prop: 'entityPlanImg',
    //         type: 'upload',
    //         mustFillInSub: true,
    //         index: 7
    //     }
    // ],
    wareHousePhotos: [
        {
            label: '卫星俯瞰图',
            imageUrl: '',
            prop: 'wxfkt',
            disabled: false,
            required: true,
            download: true
        }, { label: '园区总平面图',
            imageUrl: '',
            prop: 'yqzpmt',
            disabled: false,
            required: true,
            download: true
        }, { label: '库房外景',
            imageUrl: '',
            prop: 'whOutscene'
        }, { label: '库房内景',
            imageUrl: '',
            prop: 'whInscene'
        }, { label: '作业区',
            imageUrl: '',
            prop: 'whWorkingPark'
        }, { label: '停车区',
            imageUrl: '',
            prop: 'whPark'
        }, { label: '通道',
            imageUrl: '',
            prop: 'whPath'
        }, { label: '办公室',
            imageUrl: '',
            prop: 'whOffice'
        }, { label: '平台',
            imageUrl: '',
            prop: 'whPlatform'
        }, { label: '雨棚',
            imageUrl: '',
            prop: 'whCanopy'
        } ]
};
